
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 .833L2.5 4.167v5c0 4.625 3.2 8.95 7.5 10 4.3-1.05 7.5-5.375 7.5-10v-5L10 .833zm5.833 8.334c0 3.767-2.483 7.242-5.833 8.275-3.35-1.034-5.833-4.508-5.833-8.275V5.25L10 2.66l5.833 2.591v3.917zm-10.25 2.172l2.159 2.158a.83.83 0 001.175 0l5.491-5.492a.83.83 0 10-1.175-1.175l-4.9 4.9-1.575-1.566a.83.83 0 10-1.175 1.175z","fill":"#1D3C6F"}})])
          )
        }
      }
    